import React from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';

import './MLButton.scss';

const MLButton = ({
    children,
    className,
    external,
    variant = 'primary',
    ...props
}) => {
    const classNames = classnames(
        className,
        `ml-button-${variant}`,
        external && 'ml-button-external',
    );

    if (props.href) {
        return (
             
            <a
                className={classNames}
                {...props}
            >
                { children }
            </a>
        );
    }

    return (
        <button
            className={classNames}
            type="button"
            {...props}
        >
            {children}
        </button>
    );
};

MLButton.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    external: PropTypes.bool,
    href: PropTypes.string,
    onClick: PropTypes.func,
    variant: PropTypes.oneOf([
        'primary',
        'primary-dark',
        'secondary',
        'secondary-dark',
    ]),
};

export default MLButton;
